var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "thumbnailWrapper",
      class:
        "c-gallery-image-scroller-small " +
        (_vm.controlsLiveRegion
          ? "c-gallery-image-scroller-small--controls-live-region"
          : "")
    },
    [
      _c("div", { staticClass: "c-gallery-image-scroller-small__image-row" }, [
        _c(
          "div",
          {
            ref: "thumbnails",
            staticClass: "c-gallery-image-scroller-small__thumbnails"
          },
          [
            _vm._l(
              _vm.images.slice(
                0,
                _vm.images.length > 5 && !_vm.showAll ? 5 : _vm.images.length
              ),
              function(image, index) {
                return [
                  _c(
                    "button",
                    {
                      key: index,
                      tag: "component",
                      class:
                        "c-gallery-image-scroller-small__thumbnail-button " +
                        (_vm.controlsLiveRegion && _vm.currentIndex === index
                          ? "c-gallery-image-scroller-small__thumbnail-button--current"
                          : ""),
                      attrs: {
                        type: "button",
                        "aria-pressed": _vm.controlsLiveRegion
                          ? _vm.currentIndex === index
                          : undefined,
                        id: image.id,
                        href: _vm.isLinks ? image.href : undefined
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectImage(index, image.id)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass:
                          "c-gallery-image-scroller-small__thumbnail",
                        attrs: {
                          src:
                            !image.imageUrl && image.iframeType === "vr"
                              ? "../../../placeholders/images/gallery/exiframe2.jpg"
                              : !image.imageUrl && image.iframeType === "video"
                              ? "../../../placeholders/images/gallery/exiframe1.jpg"
                              : image.imageUrl,
                          alt: image.text,
                          title: image.text
                        }
                      }),
                      _vm._v(" "),
                      image.iframe
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "c-gallery-immage-scroller-small-iframe"
                            },
                            [
                              image.iframeType === "video"
                                ? _c("v-icon", {
                                    attrs: {
                                      name: "icon-play",
                                      cssModifiers:
                                        "c-icon--white c-list__icon c-icon--scale-big"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              image.iframeType === "vr"
                                ? _c("v-icon", {
                                    attrs: {
                                      name: "icon-360deg",
                                      cssModifiers:
                                        "c-icon--white c-list__icon c-icon--lg c-icon--padding"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ]
              }
            ),
            _vm._v(" "),
            _vm.images.length > 5 && !_vm.showAll
              ? [
                  _c(
                    "button",
                    {
                      staticClass:
                        "c-gallery-image-scroller__thumbnail-button--moreimg",
                      on: { click: _vm.toggleShowAll }
                    },
                    [_vm._v("+" + _vm._s(_vm.images.length - 5) + " fler")]
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }